export default "__VITE_ASSET__CTASBrhk__"